import React, { useState } from 'react';
import { Button, Card, CardBody, CardSubtitle, CardTitle, Col, Form, Row } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField';

//API
import secretaria_api from "../../../../api/secretaria_api";

//Helpers
import { showMessage } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';

import { setSessionCookie } from '../../../../helpers/cookies';

function Modulos({ acessos, handleReturn }) {
    // Lista de módulos para seleção
    const [optionsModulos, set_optionsModulos] = useState([
        { value: "secretaria", label: "Secretaria" },
        { value: "administrador", label: "Administrador" }
    ]);

    // State para lista de secretaria
    const [listaSecretarias, setListaSecretarias] = useState([]);

    // Módulo selecionado
    const [modulo, set_modulo] = useState("");

    //State para pegar secretaria
    const [secretaria, setSecretaria] = useState("");

    const { setLoading, signIn, logoSistema, nomeSistema, subtituloLogin } = useAuth();


    const loadingSecretarias = () => {
        setLoading(true);
        secretaria_api.getList()
            .then(response => {
                response.data.filter(s => s.status != "Inativo").map(value => {
                    value.value = value.id.toString();
                    value.label = value.identificacao;
                    return value;
                })
                setListaSecretarias(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    }

    //Change para o módulo selecionado
    const onChangeModulo = (e, select) => {
        setSecretaria("");
        setListaSecretarias([]);

        set_modulo(e);
        if (e.value == "secretaria") {
            loadingSecretarias();
        }
    }

    //Change para o módulo selecionado
    const onChangeSecretaria = (e, select) => {
        setSecretaria(e);
    }

    // Submit do formulário, para validar a autenticação
    const onSubmit = () => {
        if (modulo?.value == "secretaria" && (secretaria == "" || secretaria == null)) {
            showMessage("Aviso", "Por favor, selecione a secretaria.", "error", null)
            return;
        }

        if (modulo?.value == "secretaria" && (secretaria != null || secretaria != "")) {
            let _acessosSecretaria = { ...acessos };
            _acessosSecretaria.acesso = "secretaria";
            _acessosSecretaria.secretaria_Id = secretaria.id;
            signIn(_acessosSecretaria);
            window.location = `/admin/dashboard`;
        }
        if (modulo?.value == "administrador") {
            let _acessosAdministrador = { ...acessos };
            _acessosAdministrador.acesso = "administrador";
            signIn(_acessosAdministrador);
            window.location = `/admin/administrador/regionais`;
        }
    }

    return <>
        <Card style={{ marginTop: "10vh" }}>
            <CardBody>
                <Row className='mt-3 pl-3'>
                    <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center'>
                        <CardTitle tag={'h4'} className='mb-4 font-weight-normal'>Bem vindo ao {nomeSistema}!</CardTitle>
                        <CardSubtitle tag="p" style={{ color: "#bbb", fontSize: '10pt' }} className='mb-4'>
                            {subtituloLogin}
                        </CardSubtitle>
                        <div className="mb-3">
                            <img src={logoSistema}  alt="logo do sistema FISCSP" style={{width: "25%"}}/>
                        </div>
                    </Col>

                    <Col lg='6' md='12' className='text-left'>
                        <CardTitle tag={'h4'} className='fw-normal text-center'>Módulos de Acesso</CardTitle>
                        <div>
                            <TextField
                                label={"* Módulo"}
                                name={"modulo"}
                                type={"select"}
                                options={optionsModulos}
                                value={modulo}
                                onChange={onChangeModulo}
                                searchable
                            />
                            {listaSecretarias.length > 0 &&
                                <TextField
                                    label={"* Secretarias"}
                                    name={"secretaria"}
                                    type={"select"}
                                    options={listaSecretarias}
                                    value={secretaria}
                                    onChange={onChangeSecretaria}
                                    searchable
                                />
                            }
                            <div className='text-center text-lg-start'>
                                <a onClick={handleReturn} href="" className=" text-secondary">Voltar</a>
                            </div>
                            <div className="mt-3 d-flex justify-content-center justify-content-lg-end">
                                <Button
                                    onClick={onSubmit}
                                    type="submit"
                                    color='success'
                                    className='fw-bold px-4'
                                >
                                    Entrar
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    </>;
}

export default Modulos;